export const CLASSIFICATION_OPTIONS = [
  {
    "key": "SUBMUNITIONS_SMALL",
    "label": $localize`:@@classification.submunitions:Submunitions`,
    "type": "submunitions",
    "size": $localize`:@@size.74mmBelow:74MM x 57MM & Below`,
    "evacuationRadius": 368,
  },
  {
    "key": "SUBMUNITIONS_LARGE",
    "label": $localize`:@@classification.submunitions:Submunitions`,
    "type": "submunitions",
    "size": $localize`:@@size.75mmAbove:75MM x 58MM & Above`,
    "evacuationRadius": 585,
  },
  {
    "key": "GRENADES_SMALL",
    "label": $localize`:@@classification.grenades:Grenades`,
    "type": "grenades",
    "size": $localize`:@@size.74mmBelow:74MM x 57MM & Below`,
    "evacuationRadius": 368,
  },
  {
    "key": "GRENADES_LARGE",
    "label": $localize`:@@classification.grenades:Grenades`,
    "type": "grenades",
    "size": $localize`:@@size.75mmAbove:75MM x 58MM & Above`,
    "evacuationRadius": 585,
  },
  {
    "key": "AP_LANDMINES_SMALL",
    "label": $localize`:@@classification.apLandmines:AP Landmines`,
    "type": "landmines",
    "size": $localize`:@@size.112mmBelow:112MM x 63MM & Below`,
    "evacuationRadius": 421,
  },
  {
    "key": "AP_LANDMINES_LARGE",
    "label": $localize`:@@classification.apLandmines:AP Landmines`,
    "type": "landmines",
    "size": $localize`:@@size.113mmAbove:113MM x 64MM & Above`,
    "evacuationRadius": 620,
  },
  {
    "key": "AT_LANDMINES_SMALL",
    "label": $localize`:@@classification.atLandmines:AT Landmines`,
    "type": null,
    "size": $localize`:@@size.81mmBelow:81MM x 249MM & Below`,
    "evacuationRadius": 518,
  },
  {
    "key": "AT_LANDMINES_LARGE",
    "label": $localize`:@@classification.atLandmines:AT Landmines`,
    "type": null,
    "size": $localize`:@@size.82mmAbove:82MM x 250MM & Above`,
    "evacuationRadius": 658,
  },
  {
    "key": "PROJECTILES_SMALL",
    "label": $localize`:@@classification.projectiles:Projectiles`,
    "type": "mortar-projectiles",
    "size": $localize`:@@size.85mmBelow:85MM x 344MM & Below`,
    "evacuationRadius": 412,
  },
  {
    "key": "PROJECTILES_MEDIUM",
    "label": $localize`:@@classification.projectiles:Projectiles`,
    "type": "mortar-projectiles",
    "size": $localize`:@@size.86mmTo121mm:from 86MM x 345MM to 121MM x 500MM`,
    "evacuationRadius": 511,
  },
  {
    "key": "PROJECTILES_LARGE",
    "label": $localize`:@@classification.projectiles:Projectiles`,
    "type": "mortar-projectiles",
    "size": $localize`:@@size.122mmAbove:122MM x 501MM & Above`,
    "evacuationRadius": 707,
  },
  {
    "key": "MORTARS_SMALL",
    "label": $localize`:@@classification.mortars:Mortars`,
    "type": "mortars",
    "size": $localize`:@@size.60mmBelow:60MM x 210MM & Below`,
    "evacuationRadius": 340,
  },
  {
    "key": "MORTARS_MEDIUM",
    "label": $localize`:@@classification.mortars:Mortars`,
    "type": "mortars",
    "size": $localize`:@@size.61mmTo100mm:from 61MM x 211MM to 100MM x 280MM`,
    "evacuationRadius": 503,
  },
  {
    "key": "MORTARS_LARGE",
    "label": $localize`:@@classification.mortars:Mortars`,
    "type": "mortars",
    "size": $localize`:@@size.101mmAbove:101MM x 281MM & Above`,
    "evacuationRadius": 818,
  },
  {
    "key": "ROCKETS_SMALL",
    "label": $localize`:@@classification.rockets:Rockets`,
    "type": "rockets",
    "size": $localize`:@@size.68mmBelow:68MM x 425MM & Below`,
    "evacuationRadius": 271,
  },
  {
    "key": "ROCKETS_MEDIUM",
    "label": $localize`:@@classification.rockets:Rockets`,
    "type": "rockets",
    "size": $localize`:@@size.69mmTo107mm:from 69MM x 426MM to 107MM x 840MM`,
    "evacuationRadius": 548,
  },
  {
    "key": "ROCKETS_LARGE",
    "label": $localize`:@@classification.rockets:Rockets`,
    "type": "rockets",
    "size": $localize`:@@size.108mmAbove:108MM x 841MM & Above`,
    "evacuationRadius": 911,
  },
  {
    "key": "BOMBS_SMALL",
    "label": $localize`:@@classification.bombs:Bombs`,
    "type": "bombs",
    "size": $localize`:@@size.194mmBelow:194MM x 1M & Below`,
    "evacuationRadius": 510,
  },
  {
    "key": "BOMBS_MEDIUM",
    "label": $localize`:@@classification.bombs:Bombs`,
    "type": "bombs",
    "size": $localize`:@@size.195mmTo325mm:From 195MM x 1.01M to 325MM x 1.46M`,
    "evacuationRadius": 1079,
  },
  {
    "key": "BOMBS_LARGE",
    "label": $localize`:@@classification.bombs:Bombs`,
    "type": "bombs",
    "size": $localize`:@@size.326mmAbove:326MM x 1.47M & Above`,
    "evacuationRadius": 1969,
  },
  {
    "key": "GUIDED_MISSILES_SMALL",
    "label": $localize`:@@classification.guidedMissiles:Guided Missiles`,
    "type": "guided-missiles",
    "size": $localize`:@@size.127mmBelow:127MM x 3M & Below`,
    "evacuationRadius": 564,
  },
  {
    "key": "GUIDED_MISSILES_MEDIUM",
    "label": $localize`:@@classification.guidedMissiles:Guided Missiles`,
    "type": "guided-missiles",
    "size": $localize`:@@size.128mmTo254mm:From 128MM x 3.01M to 254MM x 4.15M`,
    "evacuationRadius": 1023,
  },
  {
    "key": "GUIDED_MISSILES_LARGE",
    "label": $localize`:@@classification.guidedMissiles:Guided Missiles`,
    "type": "guided-missiles",
    "size": $localize`:@@size.255mmAbove:255MM x 4.16M & Above`,
    "evacuationRadius": 1922,
  },
  {
    "key": "UNKNOWN",
    "label": $localize`:@@classification.unknown:Unknown`,
    "type": "unknown",
    "size": "",
    "evacuationRadius": 500,
  },
  {
    "key": "OTHER_POSSIBLE_OSSEOUS_MATERIAL",
    "label": $localize`:@@classification.osseousMaterial:Possible Osseous Material`,
    "type": "other",
    "size": "",
    "evacuationRadius": 0,
  },
  {
    "key": "OTHER_POSSIBLE_MATERIAL_EVIDENCE",
    "label": $localize`:@@classification.materialEvidence:Possible Material Evidence`,
    "type": "other",
    "size": "",
    "evacuationRadius": 0,
  },
  {
    "key": "OTHER_POSSIBLE_LIFE_SUPPORT_EQUIPMENT",
    "label": $localize`:@@classification.lifeSupportEquipment:Possible Life Support Equipment`,
    "type": "other",
    "size": "",
    "evacuationRadius": 0,
  },
  {
    "key": "OTHER_POSSIBLE_AIRCRAFT_WRECKAGE",
    "label": $localize`:@@classification.aircraftWreckage:Possible Aircraft Wreckage`,
    "type": "other",
    "size": "",
    "evacuationRadius": 0,
  },
  {
    "key": "AIRDRONE_SMALL",
    "label": $localize`:@@classification.airDrone:Air Drone`,
    "type": "airdrone",
    "size": $localize`:@@size.airdroneSmall:< 150kg`,
    "evacuationRadius": 0,
  },
  {
    "key": "AIRDRONE_MEDIUM",
    "label": $localize`:@@classification.airDrone:Air Drone`,
    "type": "airdrone",
    "size": $localize`:@@size.airdroneMedium:150 - 600kg`,
    "evacuationRadius": 0,
  },
  {
    "key": "AIRDRONE_LARGE",
    "label": $localize`:@@classification.airDrone:Air Drone`,
    "type": "airdrone",
    "size": $localize`:@@size.airdroneLarge:> 600kg`,
    "evacuationRadius": 0,
  },
  {
    "key": "LANDDRONE_SMALL",
    "label": $localize`:@@classification.landDrone:Land Drone`,
    "type": "landdrone",
    "size": $localize`:@@size.landdroneSmall:< 200kg`,
    "evacuationRadius": 0,
  },
  {
    "key": "LANDDRONE_MEDIUM",
    "label": $localize`:@@classification.landDrone:Land Drone`,
    "type": "landdrone",
    "size": $localize`:@@size.landdroneMedium:200kg - 2T`,
    "evacuationRadius": 0,
  },
  {
    "key": "LANDDRONE_LARGE",
    "label": $localize`:@@classification.landDrone:Land Drone`,
    "type": "landdrone",
    "size": $localize`:@@size.airdroneLarge:> 2T`,
    "evacuationRadius": 0,
  },
  {
    "key": "SEADRONE_SURFACE",
    "label": $localize`:@@classification.seaDrone:Sea Drone`,
    "type": "seadrone",
    "size": "",
    "evacuationRadius": 0,
  },
  {
    "key": "SEADRONE_UNDERWATER",
    "label": $localize`:@@classification.seaDrone:Sea Drone`,
    "type": "seadrone",
    "size": "",
    "evacuationRadius": 0,
  }
]